import React, { useEffect, useState } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html"
import { $getRoot } from "lexical"
import { useIntl } from "react-intl"
import { EMPTY_HTML } from "../../../../../globals"

const LexicalHtmlViewInputPlugin = ({ disabled }: { disabled: boolean }) => {
  const [editor] = useLexicalComposerContext()

  const [isHtmlMode, setIsHtmlMode] = useState<boolean>(false)
  const [editorState, setEditorState] = useState<string>("")

  const intl = useIntl()

  const updateEditorState = () => {
    editor.update(() => {
      const root = $getRoot()
      root.clear()
      const parser = new DOMParser()

      const dom = parser.parseFromString(editorState || EMPTY_HTML, "text/html")
      root.append(...$generateNodesFromDOM(editor, dom.body))
    })
  }

  const onViewToggleClick = () => {
    setIsHtmlMode((prev) => !prev)
  }

  useEffect(() => {
    // Register an update listener to get the latest editor state
    const removeUpdateListener = editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const htmlString = $generateHtmlFromNodes(editor)
        setEditorState(htmlString)
      })
    })

    return () => {
      removeUpdateListener() // Clean up the listener
    }
  }, [editor])

  useEffect(() => {
    // disable/enable editor based on the disabled prop
    if (disabled && editor) {
      editor.setEditable(false)
    } else {
      editor.setEditable(true)
    }
  }, [disabled, editor])

  return (
    <>
      <button className="LexicalEditor__viewToggle" disabled={disabled} onClick={onViewToggleClick}>
        {isHtmlMode
          ? intl.formatMessage({ id: "common.viewContent" })
          : intl.formatMessage({ id: "common.viewHTML" })}
      </button>
      {isHtmlMode && (
        <div className="LexicalEditor__htmlContent">
          <textarea
            disabled={disabled}
            className="LexicalEditor__htmlContentInput"
            onChange={(e) => setEditorState(() => e.target.value)}
            style={{ width: "100%" }}
            value={editorState}
            onBlur={() => {
              updateEditorState()
            }}
          />
        </div>
      )}
    </>
  )
}

export default LexicalHtmlViewInputPlugin
